import React from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import { Button, Link, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import SimpleModal from '../SimpleModal';

const ExportModal = (props) => {
  const { t } = useTranslation();
  const {
    type,
    open,
    onCancel,
    onConfirm,
  } = props;

  const history = useHistory();

  const handleCustomerExportsClick = (event) => {
    const isModifiedClick = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
    if (event.button !== 0 || isModifiedClick) {
      return;
    }
    event.preventDefault();
    onConfirm();
    history.push('/customers/past_exports');
  };

  const handleConfirm = () => {
    let path = '';
    onConfirm();
    if (type === 'customers') {
      return;
    }

    switch (type) {
      case 'leads':
        path = type;
        break;
      case 'submissions':
        path = `campaigns/${type}`;
        break;
      default:
        break;
    }

    if (path) {
      history.push(`/${path}/past_exports`);
    }
  };

  return (
    <SimpleModal
      title={t('export_modal.title', 'Exporting...')}
      open={open}
      onCancel={onCancel}
      content={(
        <div>
          <Typography variant="body2">
            {type === 'customers'
              ? t('export_modal.customer_description', "We'll update you via email as soon as the CSV file is ready to be downloaded. It should take less than 15 minutes. Please refresh your tab if your data is yet to be displayed.")
              : t('export_modal.description', "We'll update you via email as soon as the CSV file is ready to be downloaded. It should take less than 15 minutes")}
          </Typography>
          {type === 'customers' && (
            <Typography variant="body2">
              <br />
              {t('export_modal.customer_exports_prompt', 'Click ')}
              <Link
                href="/customers/past_exports"
                onClick={handleCustomerExportsClick}
                underline="always"
              >
                {t('export_modal.customer_exports_link', 'here')}
              </Link>
              {t('export_modal.customer_exports_suffix', ' to navigate to Customer Exports.')}
            </Typography>
          )}
        </div>
    )}
      buttons={(
        <Button
          variant="contained"
          onClick={handleConfirm}
        >
          {t('component.label.okay', 'Okay')}
        </Button>
    )}
    />
  );
};

ExportModal.propTypes = {
  type: PropTypes.oneOf(['leads', 'customers', 'submissions']),
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

ExportModal.defaultProps = {
  type: 'leads',
  open: false,
  onCancel: () => {},
  onConfirm: () => {},
};

export default ExportModal;
